import CrmAccountSession from "./session/model-session"
import CustomFieldsProxy from "../../custom-fields-proxy"
import CrmAccountAccessControl from "./access-control/access-control"

export default class CrmAccount extends CrmAccountSession {

    public accountOwnerUserId : ID
    public phone              : string
    public email              : string
    public website            : string
    public notes              : string
    public customFieldsData   : any
    public contacts           : any[]

    constructor(data: any) {
        super(data);

        this.accountOwnerUserId = data['accountOwnerUserId']
        this.phone              = data['phone']
        this.email              = data['email']
        this.website            = data['website']
        this.notes              = data['notes']
        this.customFieldsData   = data['customFieldsData']
        this.contacts           = data['contacts']

        return new Proxy(this, CustomFieldsProxy)
    }

    get acl(): CrmAccountAccessControl {
        return new CrmAccountAccessControl(this)
    }

    save() {
        const params = {}

        this.updatedFields.forEach((fieldName) => {
            params[fieldName as keyof {}] = this[fieldName as keyof {}]
        })

        return gd.api.CRM.updateAccount(this.id, params)
    }

}
